import { Injectable } from "@angular/core";
import { FormGroup, ControlContainer } from "@angular/forms";
import { Observable, of } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "@env/environment";
import { CookieService } from "ngx-cookie-service";
import { BehaviorSubject } from "rxjs";
import { LocalStorageService } from "../local-storage/local-storage.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class GlobalService {
  apiUrl = environment.baseIP + environment.apiPrefix;
  access_token: any;
  private organization_id: any;
  countries = [
    { id: '120', name: 'Jwagall' },
    { id: '121', name: 'Other Country' }
  ];

  statusOptions = [
    { value: '1', label: 'Active' },
    { value: '0', label: 'Inactive' }
  ];
  constructor(
    private httpClient: HttpClient,
    private _cookieService: CookieService,
    private localStorageService:LocalStorageService,
    private router:Router,
  ) {
    this.access_token = this._cookieService.get("access_token");
  }

  public markAsTouched(formGroup: FormGroup): void {
    formGroup.markAsTouched();
    formGroup.updateValueAndValidity();
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
      if (control.controls) {
        this.markAsTouched(control);
      }
    });
  }
  private globalSearchResultsSubject = new BehaviorSubject<any>(null);
  globalSearchResults$ = this.globalSearchResultsSubject.asObservable();
  setGlobalSearchResults(results: any): void {
    this.globalSearchResultsSubject.next(results);
  }
  clearGlobalSearchResults(): void {
    this.globalSearchResultsSubject.next(null);
  }

  // Get the list of countries
  getCountryList(): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.access_token,
      }),
    };
    return this.httpClient.post(`${this.apiUrl}country/list`, options,);
    // return of(this.countries);
  }
  CountryListService(payload: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.access_token}`
    });

    return this.httpClient.post(
      `${this.apiUrl}country/list`,
      payload,
      { headers }
    );
  }


  // globalSearchService(body): Observable<any> {
  //   const options = {
  //     headers: new HttpHeaders({
  //       "Content-Type": "application/json",
  //       Authorization: "Bearer " + this.access_token,
  //     }),
  //   };
  //   return this.httpClient.post(
  //     `${this.apiUrl}site/global-search`,
  //     body,
  //     options
  //   );
  // }

  globalSearchService(keyword: any, organizationId: number): Observable<any> {
    const headers = new HttpHeaders({
      'organizationId': organizationId.toString(),
      Authorization: "Bearer " + this.access_token,
    });
    const body = { keyword: keyword };

    return this.httpClient.post(
      `${this.apiUrl}global-search/search`,
      body, { headers: headers }
    );
  }

  getRoleListRoutes(rolename: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.access_token,
      }),
    };
    return this.httpClient.get(
      `${this.apiUrl}role/list-route?role_id=${rolename}`,
      options
    );
  }

  postSourceList(payload): Observable<any> {

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.access_token}`,
    });

    return this.httpClient.post(
      `${this.apiUrl}source/list`,
      payload,
      {
        headers,
        observe: 'response'  // This gives you full response including status
      });
  }
  allPermission: any;
  setPermission(permission: any) {
    this.allPermission = permission;
  }
  getPermission() {
    return this.allPermission;
  }

  menuListService(body): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.access_token,
      }),
    };
    return this.httpClient.post(`${this.apiUrl}menu/list`, body, options);
  }
  setOrganizationId(organization_id) {
    this.organization_id = organization_id
  }
  getOrganizationId() {
    return this.organization_id
  }

  fileDownloadService(
    file_id: string | number,
    type: string,
    organization_id: string | number
  ): Observable<any> {
    const headers = new HttpHeaders({
      organizationId: organization_id.toString(),
      Authorization: 'Bearer ' + this.access_token
    });

    const params = new HttpParams()
      .set('id', file_id.toString())
      .set('type', type.toString());

    // Use observe: 'response' to get full response including headers
    return this.httpClient.get(
      `${this.apiUrl}file/download`,
      {
        headers,
        params,
        observe: 'response',
        responseType: 'blob'
      }
    );
  }

  logout(): void {
    this.localStorageService.clearLocalStorage();
    this._cookieService.deleteAll();
    // clear browser storage
    localStorage.clear();
    sessionStorage.clear();
    // delete cookies
    this._cookieService.deleteAll('/', window.location.hostname);
    this._cookieService.deleteAll('/');

    this.router.navigate(["/login"]);
  }

}
